import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import {EN, ES, PT, VI} from '../constants'
import {ContextConsumer} from '../Context'

const styles = theme => ({
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
})

const languages = [
  {lang: EN, title: 'English'},
  {lang: ES, title: 'Español'},
  {lang: PT, title: 'Portugês'},
  {lang: VI, title: 'Tiếng Việt'},
]

class Languages extends Component {
  state = {
    anchorEl: null,
  }

  handleClick = event => {
    this.setState({anchorEl: event.currentTarget})
  }

  handleClose = () => {
    this.setState({anchorEl: null})
  }
  render() {
    const {anchorEl} = this.state
    const {classes} = this.props
    return (
      <ContextConsumer>
        {context => {
          return (
            <Fragment>
              <Button
                variant="raised"
                color="secondary"
                onClick={this.handleClick}>
                {context.language}
                <ArrowDownIcon className={classes.rightIcon} />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}>
                {languages.map(x => {
                  return (
                    <MenuItem
                      key={x.lang}
                      onClick={() => {
                        context.handleSetLanguage(x.lang)
                        this.handleClose()
                      }}>
                      {x.title}
                    </MenuItem>
                  )
                })}
              </Menu>
            </Fragment>
          )
        }}
      </ContextConsumer>
    )
  }
}

Languages.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Languages)



// WEBPACK FOOTER //
// ./src/components/Languages.js